import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PackageTable from "../../components/PackageSizes/PackageTable";
import PackageV2 from "../../components/PackageSizes/PackageV2";


const PackageSizes = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Package Sizes" />
                {/* <AddEmailTemp /> */}
                {/* <PackageTable/>/ */}

                <PackageV2/>


            </MasterLayout>
        </>
    );
};

export default PackageSizes;
